// src/Dashboard/pages/user/Messaging/components/MessagingModuleNav.jsx

import React from "react";
import { FaInbox, FaPaperPlane, FaUsers } from "react-icons/fa";

function Badge({ value, tone = "blue" }) {
  if (!value || Number(value) <= 0) return null;

  const tones = {
    blue: "bg-blue-600",
    amber: "bg-amber-600",
    emerald: "bg-emerald-600",
    indigo: "bg-indigo-600",
  };

  return (
    <span
      className={`inline-flex min-w-6 items-center justify-center rounded-full px-2 py-1 text-[11px] font-bold leading-none text-white ${
        tones[tone] || tones.blue
      }`}
    >
      {value}
    </span>
  );
}

export default function MessagingModuleNav({
  activeModule,
  onChange,
  isManager,
  unreadCount,
  receivedCount,
  sentCount,
  channelsCount,
}) {
  const modules = [
    {
      id: "received",
      title: "Messages reçus",
      subtitle: "Boîte de réception",
      icon: FaInbox,
      badge: unreadCount,
      badgeTone: "amber",
      count: receivedCount,
    },
    {
      id: "sent",
      title: "Messages envoyés",
      subtitle: "Historique personnel",
      icon: FaPaperPlane,
      badge: 0,
      count: sentCount,
    },
    {
      id: "channels",
      title: "Canaux",
      subtitle: "Discussions de groupes",
      icon: FaUsers,
      badge: 0,
      count: channelsCount,
    },
  ];

  return (
    <>
      <div className="-mx-2 overflow-x-auto px-2 lg:hidden">
        <div className="flex gap-2 pb-2">
          {modules.map((item) => {
            const active = activeModule === item.id;
            const Icon = item.icon;

            return (
              <button
                key={item.id}
                type="button"
                onClick={() => onChange(item.id)}
                className={`inline-flex shrink-0 items-center gap-2 rounded-2xl px-4 py-3 text-sm font-bold ring-1 transition ${
                  active
                    ? "bg-[#013E8E] text-white ring-[#013E8E]"
                    : "bg-white text-slate-700 ring-slate-200 hover:bg-slate-50 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-800"
                }`}
              >
                <Icon />
                {item.title}
                <Badge value={item.badge} tone={item.badgeTone} />
              </button>
            );
          })}
        </div>
      </div>

      <aside className="hidden lg:block">
        <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

          <div className="p-3">
            {modules.map((item) => {
              const active = activeModule === item.id;
              const Icon = item.icon;

              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => onChange(item.id)}
                  className={`mb-2 flex w-full items-center justify-between gap-3 rounded-[22px] px-4 py-3 text-left transition last:mb-0 ${
                    active
                      ? "bg-[#013E8E] text-white shadow-sm"
                      : "bg-slate-50 text-slate-700 hover:bg-slate-100 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
                  }`}
                >
                  <span className="flex min-w-0 items-center gap-3">
                    <span
                      className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl ${
                        active
                          ? "bg-white/15"
                          : "bg-white ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700"
                      }`}
                    >
                      <Icon />
                    </span>

                    <span className="min-w-0">
                      <span className="block text-sm font-bold">
                        {item.title}
                      </span>
                      <span
                        className={`mt-0.5 block truncate text-xs ${
                          active
                            ? "text-white/75"
                            : "text-slate-500 dark:text-slate-400"
                        }`}
                      >
                        {item.subtitle}
                      </span>
                    </span>
                  </span>

                  <span className="flex items-center gap-2">
                    <Badge value={item.badge} tone={item.badgeTone} />
                    <span
                      className={`text-xs font-bold ${
                        active ? "text-white/80" : "text-slate-400"
                      }`}
                    >
                      {item.count}
                    </span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </aside>
    </>
  );
}